<div class="d-flex flex-nowrap mb-2">
  <div ngbDropdown
       container="body"
       class="dropdown d-none d-sm-inline-block d-lg-none"
       placement="left"
       [ngbTooltip]="!isMobile ? 'More' : ''">
    <button ngbDropdownToggle
            class="waitlist btn btn-info btn-icon mr-2"
            type="button"
            aria-haspopup="true"
            aria-expanded="false"
    >
      <span class="bi bi-three-dots"></span>
    </button>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
      <a ngbDropdownItem
         class="dropdown-item flex"
         (click)="callbacks.addEditParty(party)">
        <tr-icon [icon]="icon.edit" classes="pr-2"></tr-icon>Edit
      </a>
      <span [ngbTooltip]="chatTooltip(party?.phone)" container="body">
        <a ngbDropdownItem
           [class.disabled]="!party?.phone"
           class="dropdown-item flex align-items-center"
           (click)="callbacks.chatParty(party, index)">
          <tr-icon [icon]="icon.chat" [disabled]="!party?.phone" classes="pr-2"></tr-icon>Chat
        </a>
      </span>
    </div>
  </div>

  <button
    (mousedown)="chatBtnFocus[index] = true"
    (mouseup)="chatBtnFocus[index] = false"
    [ngbTooltip]="chatTooltip(party?.phone)"
    container="body"
    class="btn btn-icon btn-info-outline d-inline-block d-sm-none d-lg-inline-block mr-2"
    id="chat-party-{{index}}"
    (click)="callbacks.chatParty(party, index)"
    [disabled]="!party?.phone"
  >
    <tr-icon [icon]="icon.chat" [color]="chatBtnFocus[index] ? color.white : color.blue"></tr-icon>
  </button>
  <button class="waitlist btn btn-icon btn-info mr-2 d-inline-block d-sm-none d-lg-inline-block" placement="top" container="body" [ngbTooltip]="!isMobile ? 'Edit' : ''" id="edit-party-{{index}}"
          (click)="callbacks.addEditParty(party)">
    <tr-icon [icon]="icon.edit" [white]="true"></tr-icon>
  </button>
  <button class="waitlist btn btn-icon btn-danger mr-2" (click)="callbacks.confirmDelete(party)" angularticsCategory="waitlist" angulartics2On="click" angularticsAction="canceled waiting party" id="cancel-party-{{index}}">
    <tr-icon [icon]="icon.cancel" placement="top" [white]="true" [ngbTooltip]="!isMobile ? 'Cancel' : ''" container="body"></tr-icon>
  </button>
  <button (click)="callbacks.checkPartyResources(party)" class="waitlist btn btn-icon btn-success" [disabled]="togoMode ? false : !party?.checkin_time" angularticsCategory="waitlist" angulartics2On="click"
          angularticsAction="served waiting party" id="serve-party-{{index}}">
    <tr-icon [icon]="icon.check" [white]="true" container="body" [ngbTooltip]="!isMobile ? 'Served' : ''" placement="top" classes="tr-bullet"></tr-icon>
  </button>
</div>
